import Navigation from "./navigation";
import Action from "./action";

Navigation.Action = Action;

export default Navigation;
